import React, { Component } from 'react';
import { classname } from 'utils';
import { Button } from 'elements';
import './CookieBanner.css';

const STORAGE_KEY = 'nimax_analytics_consent';

export default class CookieBanner extends Component {
  cl = classname('cookie-banner');

  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    if (!process.browser) return;

    // Останавливаем Яндекс.Метрику, если согласие не дано
    const consent = localStorage.getItem(STORAGE_KEY);
    if (consent !== 'accepted') {
      this.stopYandexMetrika();
    }

    // Проверяем, нужно ли показывать баннер
    if (this.shouldShowBanner()) {
      this.setState({ isVisible: true });
    }
  }

  shouldShowBanner = () => {
    // Показываем баннер только если согласие не дано
    const consent = localStorage.getItem(STORAGE_KEY);
    return consent !== 'accepted';
  };

  loadYandexMetrika = () => {
    // Проверяем согласие перед загрузкой
    const consent = localStorage.getItem(STORAGE_KEY);
    if (consent !== 'accepted') {
      return; // Не загружаем без согласия
    }

    if (typeof window === 'undefined' || window.ym) {
      return; // Метрика уже загружена или мы на сервере
    }

    // Проверяем, не загружен ли уже скрипт
    const existingScript = document.querySelector('script[src="https://mc.yandex.ru/metrika/tag.js"]');
    if (existingScript) {
      return;
    }

    // Загружаем Яндекс.Метрику динамически
    (function(ratingRuneta) {
      var rrcid = new URLSearchParams(window.location.search).get(ratingRuneta);
      if (rrcid) window.sessionStorage.setItem(ratingRuneta, rrcid);
      rrcid = window.sessionStorage.getItem(ratingRuneta);
      
      (function(m, e, t, r, i, k, a) {
        m[i] = m[i] || function() {
          (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
          if (document.scripts[j].src === r) {
            return;
          }
        }
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
      
      ym(92096748, 'init', {
        clickmap: false,
        trackLinks: false,
        accurateTrackBounce: true,
        webvisor: false,
        params: {
          rrcid: rrcid
        }
      });
    })('rrcid');
  };

  logConsent = async (consent) => {
    try {
      await fetch('https://nimax.ru/wp-json/nimax/v1/log', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: 'nimax_react',
          source_type: 'cookie_banner',
          content: {
            timestamp: new Date().toISOString(),
            consent: consent,
            source: window.location.toString(),
            userAgent: navigator.userAgent || 'unknown',
          },
        }),
      });
    } catch (error) {
      console.error('Failed to log consent:', error);
    }
  };

  handleAccept = () => {
    // Сохраняем согласие
    localStorage.setItem(STORAGE_KEY, 'accepted');
    
    // Загружаем Яндекс.Метрику
    this.loadYandexMetrika();
    
    // Логируем согласие
    this.logConsent(true);
    
    // Закрываем баннер
    this.setState({ isVisible: false });
  };

  stopYandexMetrika = () => {
    // Останавливаем Яндекс.Метрику, если она была загружена
    if (typeof window === 'undefined') return;

    try {
      // Блокируем загрузку метрики через переопределение ym ДО проверки счетчиков
      window.ym = function() {
        // Блокируем все вызовы Яндекс.Метрики
      };

      // Очищаем очередь вызовов, если она существует
      if (window.ym && window.ym.a) {
        window.ym.a = [];
      }

      // Удаляем все счетчики Яндекс.Метрики
      // Проверяем все возможные варианты счетчиков
      Object.keys(window).forEach(key => {
        if (key.startsWith('yaCounter')) {
          try {
            if (window[key] && typeof window[key].destroy === 'function') {
              window[key].destroy();
            }
            delete window[key];
          } catch (e) {
            // Игнорируем ошибки
          }
        }
      });

      // Удаляем скрипты метрики
      const scripts = document.querySelectorAll('script[src*="mc.yandex.ru/metrika"], script[src*="yandex.ru/metrika"]');
      scripts.forEach(script => {
        try {
          script.remove();
        } catch (e) {
          // Игнорируем ошибки
        }
      });

      // Удаляем iframe метрики, если есть
      const iframes = document.querySelectorAll('iframe[src*="mc.yandex.ru"], iframe[src*="yandex.ru/metrika"]');
      iframes.forEach(iframe => {
        try {
          iframe.remove();
        } catch (e) {
          // Игнорируем ошибки
        }
      });
    } catch (e) {
      console.error('Error stopping Yandex Metrika:', e);
    }
  };

  handleReject = () => {
    // Останавливаем Яндекс.Метрику, если она была загружена
    this.stopYandexMetrika();
    
    // Логируем отказ
    this.logConsent(false);
    
    // Закрываем баннер
    this.setState({ isVisible: false });
  };

  render() {
    const { isVisible } = this.state;

    if (!isVisible || !process.browser) {
      return null;
    }

    return (
      <div className={this.cl()}>
        <div className={this.cl('container')}>
          <div className={this.cl('content')}>
            <p className={this.cl('text')}>
              Мы используем файлы куки  Яндекс.Метрики на сайте для улучшения вашего клиентского опыта. Нажимая «Принять» вы соглашаетесь на их использование.
              <a
                href="https://nimax.ru/privacy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className={this.cl('link')}
              >
                Подробнее
              </a>
            </p>
            <div className={this.cl('actions')}>
              <Button
                className={this.cl('button', { accept: true })}
                onClick={this.handleAccept}
                size="s"
              >
                Принять
              </Button>
              <Button
                className={this.cl('button')}
                onClick={this.handleReject}
                size="s"
                variant="reject"
              >
                Отклонить
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

